<template>
  <div class="margin-top-2">
    <div
      class="flex items-center justify-between margin-bottom-2 banner-header"
    >
      <p class="editorial">{{ title }}</p>
    </div>

    <div class="flex flex col gap-2 banner-actions-holder">
      <div class="flex items-center justify-between w-full pb-2">
        <button
          class="flex items-center gap-1.5 banner-action w-max"
          @click="$emit('onPrevStep')"
          v-if="currentStep > 1"
        >
          <img src="@/assets/back-arrow-bold.svg" alt="" class="" />
          <p><strong>Back</strong></p>
        </button>
        <div class="flex items-center gap-4 w-max ml-auto">
          <button
            v-if="canSkip"
            class="flex items-center gap-2 banner-action"
            @click="$emit('onSkipStep')"
          >
            <p class="skip-text">Skip this step</p>
          </button>
          <div
            v-if="currentStep === totalGroupOrderStep"
            class="button-area"
            :class="{ disabled: groupOrderDetails.state === 'finalized' }"
          >
            <button
              class="button-gemnote button-gemnote--small"
              :disabled="groupOrderDetails.state === 'finalized'"
              @click="$emit('onNextStep')"
            >
              <span v-if="isEdit">Confirm your changes</span>
              <span v-else>Create Redemption Page</span>
            </button>
          </div>
          <button
            v-else
            class="flex items-center gap-2 banner-action"
            @click="$emit('onNextStep')"
          >
            <p><strong>Next</strong></p>
            <img
              src="@/assets/next-arrow-bold.svg"
              alt=""
              class="rotate-[90deg]"
            />
          </button>
        </div>
      </div>
    </div>
    <div class="banner-info flex items-center justify-between">
      <p class="banner-info__text">
        <strong>{{ headerText || 'Header Text' }}</strong>
      </p>
      <div class="banner-info__step" v-if="currentStep !== totalGroupOrderStep">
        <p>Step {{ currentStep }}/ {{ totalGroupOrderStep }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'GroupOrderCreate',
  props: {
    currentStep: {
      default: 1,
      type: Number
    },
    title: {
      required: true,
      type: String
    },
    headerText: {
      required: true,
      type: String
    },
    canSkip: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      groupOrderDetails: state => state.groupOrder.groupOrderDetails,
      creatingGroupOrderStep: state => state.groupOrder.creatingGroupOrderStep,
      totalGroupOrderStep: state => state.groupOrder.totalGroupOrderStep
    })
  }
}
</script>

<style lang="scss" scoped>
.banner-header {
  .editorial {
    font-size: 1.5rem;
  }

  p {
    font-size: 0.838rem;
  }
}
.banner-actions-holder {
  border-bottom: 1px solid #dfdad2;
  .banner-action {
    p {
      font-size: 0.838rem;
    }
    .skip-text {
      font-weight: 300;
    }
  }
}
.banner-info {
  margin-top: 0.5rem;
  background-color: #dfdad2;
  padding: 1rem 1.66rem;
  @media (max-width: 768px) {
    padding: 1rem;
  }

  .banner-info__text {
    font-size: 0.913rem;
  }

  .banner-info__step {
    p {
      color: #514d43;
      font-size: 0.715rem;
      font-weight: 300;
    }
  }
}
.button-area {
  display: flex;
  justify-content: center;
  align-items: center;

  button {
    height: 2.8rem;
    text-transform: uppercase;
    padding: 0 2rem !important;
    font-weight: 400;
  }
}
</style>
